<template lang="pug">
  div
    .row(v-if="isBhpEnvironment")
        .col-md-12(v-if="loyaltyDetails.details")
            small.dark.block.text-center.m-y-sm eCard Details

        .col-md-12.table-responsive(v-if="loyaltyDetails.details")
            table.m-b-0
              tbody
                  tr(v-if="loyaltyDetails.details.customerName")
                    td(colspan=3).font-weight-bold {{ loyaltyDetails.details.customerName }}
                  tr(v-if="loyaltyDetails.details.cardNumber")
                    td eCard No.
                    td :
                    td.text-right {{ loyaltyDetails.details.cardNumber }}
                  tr(v-if="loyaltyDetails.details.merchantNo")
                    td Merchant No.
                    td :
                    td.text-right {{ loyaltyDetails.details.merchantNo }}
                  tr(v-if="loyaltyDetails.details.refNo")
                    td Reference No.
                    td :
                    td.text-right {{ loyaltyDetails.details.refNo }}
                  tr(v-if="loyaltyDetails.details.openingPoints")
                    td Points Balance
                    td :
                    td.text-right {{ loyaltyDetails.details.openingPoints }} pts
                  tr(v-if="loyaltyDetails.details.issuedPoints")
                    td Points Earned
                    td :
                    td.text-right {{ loyaltyDetails.details.issuedPoints }} pts
                  tr(v-if="loyaltyDetails.details.pointsBalance")
                    td New Balance
                    td :
                    td.text-right {{ loyaltyDetails.details.pointsBalance }} pts
                  tr(v-if="loyaltyDetails.details.pointsExpiry").font-weight-bold
                    td ePoints Expiry
                    td :
                    td.text-right
                      div(v-for="epointsExpiry in loyaltyDetails.details.pointsExpiry")
                        div {{ epointsExpiry.val }} pts - {{ epointsExpiry.expiry }}

    .row(v-else)
        .col-md-12
            small.dark.block.text-center.m-y-sm Loyalty Details

        template(v-if="loyaltyDetails")
          .col-md-12
            .col-md-12.col-flex
                table.m-b-0.text-center
                  tbody
                    template(v-if="loyaltyDetails.source === 'shell_bonuslink'")
                      tr
                        td(colspan=3).font-weight-bold BonusLink: {{ formatLoyaltyId(loyaltyDetails.loyalty_id) }}
                      tr
                        td(colspan=3).p-y-1 Muat turun Aplikasi Shell untuk nikmati ganjaran ekstra
                      tr
                        td(colspan=3).p-b-1 Download the Shell App to enjoy extra rewards.
                      tr
                        td(colspan=3).p-b-1
                          u www.shell.com.my/app

                    template(v-if="['shell_app', 'shell_dynamicqr'].includes(loyaltyDetails.source)")
                      tr
                        td(colspan=3).font-weight-bold Shell App: {{ formatLoyaltyId(loyaltyDetails.loyalty_id) }}
                      tr
                        td(colspan=3).p-y-1 Semak ganjaran anda di Aplikasi Shell hari ini
                      tr
                        td(colspan=3).p-b-1 View your rewards on the Shell App today
                      tr
                        td(colspan=3).p-b-1
                          u www.shell.com.my/app

        template(v-else)
          .col-md-12
            .col-md-12.col-flex
                table.m-b-0.text-center
                  tbody
                      tr
                        td(colspan=3).font-weight-bold Tiada kad kesetiaan / No loyalty card
                      tr
                        td(colspan=3).p-y-1 Muat turun Aplikasi Shell untuk nikmati ganjaran ekstra
                      tr
                        td(colspan=3).p-b-1 Download the Shell App to enjoy extra rewards.
                      tr
                        td(colspan=3).p-b-1
                          u www.shell.com.my/app

</template>

<script>
import receiptMixin from '../../mixins/receipt';
import { mapGetters } from 'vuex';
import Auth from '@js/plugins/auth';
import Unleash from '@js/plugins/unleash';

export default {
    mixins: [receiptMixin],

    computed: {
        ...mapGetters('transactionPostgres', ['loyaltyDetails']),

        isBhpEnvironment() {
            return Auth.metas().environment === 'bhp';
        },

        hasReceiptLoyaltyDetailsMask12DisplayLast4() {
            return Unleash.hasFeature(
                'receipt_loyalty_details_mask_12_display_last_4',
            );
        },
    },

    methods: {
        formatLoyaltyId(loyaltyId) {
            if (this.hasReceiptLoyaltyDetailsMask12DisplayLast4) {
                return '*'.repeat(12) + String(loyaltyId.slice(-4));
            }

            return '*'.repeat(11) + String(loyaltyId.split('=')[0]).slice(-4);
        },
    },
};
</script>

<style lang="scss" scoped>
table {
    width: 100%;
}

table tr td {
    vertical-align: top !important;
}

.col-flex {
    display: flex;
    border: 2px solid #000;
    padding: 10px;
    border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/receipt-postgres/loyalty-details.vue